import find from 'lodash/find';

export const subUserIsBeingEdited = state => find(state.subUsersCollection.users, user => user.editing);